var _FallbackPatientInfoL, _Divider, _Divider2;
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, Divider, Skeleton, Stack, Typography } from '@lumahealthhq/ui-core';
import FallbackPatientInfoLoader from './FallbackPatientInfoLoader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackPatientFormStepLoader() {
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 5,
    children: [_FallbackPatientInfoL || (_FallbackPatientInfoL = /*#__PURE__*/_jsx(FallbackPatientInfoLoader, {})), _Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      children: intl.formatMessage({
        id: "2FcKja",
        defaultMessage: [{
          "type": 0,
          "value": "Pre-scheduling form"
        }]
      })
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 48,
      sx: {
        transform: 'none'
      }
    }), /*#__PURE__*/_jsxs(Stack, {
      sx: {
        mt: 1,
        mb: 0,
        flex: 1
      },
      gap: 4,
      children: [_Divider2 || (_Divider2 = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 2,
        justifyContent: "flex-end",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: true,
          variant: "text",
          children: intl.formatMessage({
            id: "47FYwb",
            defaultMessage: [{
              "type": 0,
              "value": "Cancel"
            }]
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: true,
          variant: "secondary",
          children: intl.formatMessage({
            id: "cyR7Kh",
            defaultMessage: [{
              "type": 0,
              "value": "Back"
            }]
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: true,
          variant: "primary",
          children: intl.formatMessage({
            id: "7G5Qev",
            defaultMessage: [{
              "type": 0,
              "value": "View schedule"
            }]
          })
        })]
      })]
    })]
  });
}